import { PagedMultiSelectField, PagedSingleSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { locationService } from "../api/locationService";

interface Props {
	name: string;
	label: string;
	required?: boolean;
}

export const LocationSelectFields: FC<Props> = (props) => {
	return <PagedSingleSelectField {...props} fetchConfig={laravelServiceSelectFetchConfig(locationService)} />;
};

export const LocationMultiSelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={laravelServiceSelectFetchConfig(locationService)} />;
};
